import { Box, Chip } from '@mui/material'
import { SANCTION_SOURCES } from './sanctionsSources'
import { useTranslation } from 'react-i18next'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import './sanctionsSummary.scss'

const SanctionsSummary = ({ checkDetails, type }) => {
  const { t } = useTranslation(['common'])
  const sourceHits = {}

  if (Array.isArray(checkDetails.SanctionsHistory)) {
    checkDetails.SanctionsHistory.forEach((entry) => {
      const sourceKey = entry.Source?.toLowerCase?.().trim()
      if (sourceKey) {
        sourceHits[sourceKey] = true
      }
    })
  }

  const hasSanctions = checkDetails.SanctionsHistory && checkDetails.SanctionsHistory.length > 0
  const isCurrentlyPEP = checkDetails.IsCurrentlyPEP

  const items = [
    ...Object.entries(SANCTION_SOURCES).map(([key, label]) => ({
      label,
      isHit: !!sourceHits[key],
    })),
  ]

  return (
    <>
      <Box className="sanctions-summary">
        <Chip
          style={{ backgroundColor: isCurrentlyPEP ? '#ff8a00' : '#00b85f' }}
          label={
            isCurrentlyPEP
              ? t(`common:isCurrentlyPEP${type === 'BUSINESS' ? type : ''}`)
              : t(`common:isNotPEP${type === 'BUSINESS' ? type : ''}`)
          }
        />
        <Chip
          style={{ backgroundColor: hasSanctions ? '#ff8a00' : '#00b85f' }}
          label={hasSanctions ? t('common:isCurrentlySanctioned') : t('common:isNotSanctioned')}
        />
      </Box>
      <Box className="sanctions-summary-items">
        {items.map((item, index) => (
          <div key={index} className="sanctions-summary-item">
            <span>{item.isHit ? <CloseIcon color="error" /> : <CheckIcon color="primary" />}</span>
            <span>{item.label}</span>
          </div>
        ))}
      </Box>
    </>
  )
}

export default SanctionsSummary
